module.exports = __webpack_public_path__ + "static/img/3.182ff62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/3.jpg
// module id = GYko
// module chunks = 1